<template lang="pug">
    div
        .form__title
            slot(name='title')
        form.form__body.form__body_small(action='javascript://' v-if='params')
            template(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                .form__field
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfNumbers') }}
                    .form__field-body
                        cs-spin-input(
                            :value="params.amountOfNumbers",
                            :max="amountOfNumbers",
                            :min="3",
                            @increase="increaseAmountOfNumbers",
                            @decrease="decreaseAmountOfNumbers",
                            @input="params.amountOfNumbers = $event",
                            @blur="handleBlur"
                        )
                .form__field
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfOpenedFields') }}
                    .form__field-body
                        cs-spin-input(
                            :value="params.amountOfOpenedFields",
                            :max="params.amountOfNumbers",
                            :min="0",
                            @increase="increaseAmountOfOpenedFields",
                            @decrease="decreaseAmountOfOpenedFields",
                            @input="params.amountOfOpenedFields = $event",
                        )
                .form__field
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_selectAll') }}
                    .form__field-body-checkbox
                        cs-checkbox(
                        :checked="isChosenAllOpenedFields"
                        @change="choseAllOpenedFields"
                        )
                .form__field
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_repeatedNumbers') }}
                    .form__field-body
                        cs-spin-input(
                            :value="params.repeatedNumbers",
                            :max="Math.floor(params.amountOfNumbers / 2)",
                            :min="minValueRepeatedNumbers",
                            @increase="increaseRepeatedNumbers",
                            @decrease="decreaseRepeatedNumbers",
                            @input="params.repeatedNumbers = $event",
                        )
            divider
            slot(name='parameters')
            slot(name='help')
            .form__buttons(v-if='!usersIds')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                template(v-if="gameMode === 'free-game'")
                    cs-button.form__button(color="blue", @click='saveGameMode', :disabled="isInvalidAmountOfOpened || isInvalidAmountOfNumbers")
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                template(v-else='')
                    cs-button.form__button(color="blue", @click='saveGame', :disabled="isInvalidAmountOfOpened || isInvalidAmountOfNumbers")
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
            .form__buttons(v-else='')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                cs-button.form__button(color="blue", @click='saveGame', :disabled="isInvalidAmountOfOpened || isInvalidAmountOfNumbers")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_saveDifference') }}
</template>

<script>
    import GameFormMixin from '../../../utils/trainer/GameFormMixin';
    import { getInitParameters } from '@/utils/trainer/getInitParameters';
    import { mapState } from 'vuex';
    import TrainerGames from '../../../config/trainer';
    import { cloneDeep } from 'lodash';
    import multiplayerFormMixin from '../../../utils/multiplayer/formMixin';

    export default {
        props: {
            slug: String,
            courseType: String,
            id: [Number, String],
            usersIds: [Array, String],
            homeworkId: [Number, String],
            gameMode: String,
            gameId: [Number, String],
            generatorGameIndex: Number,
            generatorSettings: Boolean,
            levelAnswerDuration: Number,
        },
        mixins: [GameFormMixin, multiplayerFormMixin],
        mounted() {
            if (this.gameMode === 'free-game') {
                if (this.game && this.game.slug === this.slug) {
                    this.params = cloneDeep(this.game);
                } else if (this.gamesParameters) {
                    this.$set(
                        this,
                        'params',
                        getInitParameters({
                            slug: this.slug,
                            parameters: {
                                default: cloneDeep(this.gamesParameters[this.slug]),
                            },
                        })
                    );
                } else {
                    this.params = cloneDeep(TrainerGames.games).find(
                        item => item.slug === this.slug
                    ).parameters.default;
                }
            } else {
                this.setInitParams(this.getKey(this.usersIds));
            }
        },
        data() {
            return {
                amountOfNumbers: 20,
                amountOfOpenedFields: 3,
                repeatedNumbers: 0,
                params: null,
            };
        },
        watch: {
            'params.amountOfNumbers': {
                handler(newValue, oldValue) {
                    if (
                        ((newValue > 10 && newValue > oldValue) || oldValue === 3) &&
                        this.params.repeatedNumbers <= Math.floor(this.params.amountOfNumbers / 2)
                    ) {
                        this.params.repeatedNumbers = newValue - 10;
                    }
                    if (this.params.repeatedNumbers !== 0 && newValue < oldValue && newValue >= 10) {
                        this.params.repeatedNumbers = newValue - 10;
                    }
                    if (newValue <= 10) {
                        this.params.repeatedNumbers = 0;
                    }
                },
            },
        },
        computed: {
            ...mapState({
                game: state => state.trainer.game,
                homework: state => state.trainer.homework,
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user,
            }),
            isInvalidAmountOfOpened() {
                return (
                    this.params.amountOfOpenedFields > this.params.amountOfNumbers ||
                    this.params.amountOfOpenedFields < 0
                );
            },
            isInvalidAmountOfNumbers() {
                return this.params.amountOfNumbers > 20 || this.params.amountOfNumbers < 3;
            },
            isChosenAllOpenedFields() {
                if (this.params.amountOfOpenedFields === this.params.amountOfNumbers) {
                    return !!this.params.amountOfOpenedFields;
                }
                return false;
            },
            minValueRepeatedNumbers() {
                if (this.params.amountOfNumbers > 10) {
                    return this.params.amountOfNumbers - 10;
                }
                return 0;
            },
        },
        methods: {
            handleBlur(event) {
                if (event.target.value > 20) {
                    this.params.amountOfNumbers = null;
                    this.$nextTick(() => (this.params.amountOfNumbers = 20));
                }
                if (event.target.value < 3) {
                    this.params.amountOfNumbers = null;
                    this.$nextTick(() => (this.params.amountOfNumbers = 3));
                }
            },
            choseAllOpenedFields() {
                if (this.params.amountOfNumbers) {
                    this.params.amountOfOpenedFields = this.params.amountOfNumbers;
                }
            },
            increaseAmountOfNumbers() {
                if (this.params.amountOfNumbers !== this.amountOfNumbers) {
                    this.params.amountOfNumbers += 1;
                }
            },
            decreaseAmountOfNumbers() {
                if (this.params.amountOfNumbers !== 3) {
                    this.params.amountOfNumbers -= 1;
                }
            },
            increaseAmountOfOpenedFields() {
                if (this.params.amountOfOpenedFields !== this.params.amountOfNumbers) {
                    this.params.amountOfOpenedFields += 1;
                }
            },
            decreaseAmountOfOpenedFields() {
                if (this.params.amountOfOpenedFields !== 0) {
                    this.params.amountOfOpenedFields -= 1;
                }
            },
            increaseRepeatedNumbers() {
                if (this.params.repeatedNumbers !== Math.floor(this.params.amountOfNumbers / 2)) {
                    this.params.repeatedNumbers += 1;
                }
            },
            decreaseRepeatedNumbers() {
                if (this.params.repeatedNumbers !== 0) {
                    this.params.repeatedNumbers -= 1;
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        box-sizing: border-box;
        @include media($lg) {
            padding: 0 4.5%;
        }
    }

    .form__body_small {
        margin: 0 auto;
        max-width: 1020px;
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }

    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: 0.5rem;
        @include media($md) {
            width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            max-width: none;
            min-width: 13em;
        }
    }

    .form__field-body {
        flex-grow: 5;
    }

    .form__buttons {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
        }
    }

    .form__button {
        margin: 10px 50px;
        @include media($md) {
            margin: 0 10px;
        }
    }
</style>
